<!-- <app-header></app-header> -->
<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<div class="wrap">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
